import React from 'react';
import clsx from 'clsx';

const FormSubmit = (props) => {
  const { className, ...rest } = props;
  const classes = clsx('button', 'form__submit', className);
  return (
    <input
      type="submit"
      className={classes}
      {...rest}
    />
  );
};

export default FormSubmit;
